import { defineMessages, IntlShape } from "react-intl";

import SavedAddressType from "@mapmycustomers/shared/enum/SavedAddressType";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages<SavedAddressType>({
  [SavedAddressType.CUSTOM]: {
    id: "savedLocations.type.custom",
    defaultMessage: "Saved location",
    description: "Type name of a saved location the rep named themselves",
  },
  [SavedAddressType.HOME]: {
    id: "savedLocations.type.home",
    defaultMessage: "Home",
    description: "Name of the rep's Home saved location",
  },
  [SavedAddressType.WORK]: {
    id: "savedLocations.type.work",
    defaultMessage: "Work",
    description: "Name of the rep's Work saved location",
  },
});

const getSavedAddressTypeDisplayName = (intl: IntlShape, savedAddressType: SavedAddressType) =>
  getDisplayName(intl, messages, savedAddressType, "SavedAddressType");

export default getSavedAddressTypeDisplayName;
